import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NpsDialogComponent } from './nps-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { MatSliderModule } from '@angular/material/slider'; 

@NgModule({
  declarations: [
    NpsDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatSliderModule
  ]
})
export class NpsDialogModule { }
